export default {
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || "",
  public: process.env.REACT_APP_PUBLIC || "",
  apiroot: process.env.REACT_APP_API_ROOT || "",
  homePage: process.env.REACT_APP_HOMEPAGE || "/",
  amity_region: process.env.REACT_APP_AMITY_REGION || "",
  amity_api_key: process.env.REACT_APP_AMITY_API_KEY || "",
  amity_default_user_id: process.env.REACT_APP_AMITY_DEFAULT_USER_ID || "",
  amity_default_user_name: process.env.REACT_APP_AMITY_DEFAULT_USER_NAME || "",
  google_client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  google_redirect_uri: process.env.REACT_APP_GOOGLE_REDIRECT_URI || "",
  stripe_secret: process.env.REACT_APP_STRIPE_SECRET || "",
  stripe_public: process.env.REACT_APP_STRIPE_PUBLIC || "",
};
